<template>
    <span>
        <loading  :active.sync="isLoading"
                  :is-full-page="fullPage"
        ></loading>
        <slot></slot>
        <div>
            <table class="table">
                <thead>
                <tr>
                    <th class="col-xs-3">日期</th>
                    <th class="col-xs-3">假別</th>
                    <th class="col-xs-2">時數</th>
                    <th class="col-xs-2">動作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, key) of dates">
                    <td>
                        <input type="date" v-model="dates[key].date">
                    </td>
                    <td>
                        <select v-model="dates[key].type" class="form-control">
                            <option value="" v-for="(type, v) in typeOptions" :value="v">{{ type }}</option>
                        </select>
                    </td>
                    <td>
                        <input type="number" min="0.5" :max="workHoursPerDay" step="0.5" v-bind:value="dates[key].duration/3600" v-on:input="updateDuration($event, key)">
                    </td>
                    <td>
                        <button class="btn-danger btn-sm" v-on:click.prevent="deleteRow(key)">刪除</button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="add-buttons">
                <button type="button" class="btn add-button btn-default" v-on:click="addRow">+ 增加一天</button>
                <button type="button" v-if='!addDaysOpen' class="btn add-button btn-default ml-auto" v-on:click="addDaysOpen = true">+ 新增多天</button>
                <div class="add-days ml-auto" v-if='addDaysOpen'>
                    <div class='inputs'>
                        從 <input type="date" v-model='addDaysStartDate'/> 到 <input type="date" v-model='addDaysEndDate'/>
                    </div>
                    
                    <select v-model="addDayoffType" class="form-control">
                        <option value="" v-for="(type, v) in typeOptions" :value="v">{{ type }}</option>
                    </select>

                    <div class="buttons">
                        <button type="button" class="btn add-button btn-default" v-on:click="addDays">新增</button>
                        <button type="button" class="btn add-button" v-on:click="closeAddDays">取消</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="hidden-input hidden">
            <table>
                <tr v-for="(data, key) in dates">
                    <td v-for="(column, name) in data">
                        <label>{{ name }}
                            <input type="text" v-model="dates[key][name]" :name="generateName(name, [key, name])">
                        </label>
                    </td>
                </tr>
            </table>
        </div>
    </span>
</template>

<style scoped>
    .add-buttons {
        display: flex;
        align-items: flex-start;
    }
    .ml-auto {
        margin-left: auto;
    }
    .add-button {
        display: inline-block;
    }
    .add-days {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-end;
    }

</style>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Axios from 'axios';
  import { format, addDays, subDays } from 'date-fns';

  export default {
    computed: {
    },
    props: {
      'default-value': {
        type: Array,
        default: [],
      },
      'type-options': {
        type: Object,
        default: [],
      },
      'current-dayoff-uuid': {
        type: String,
        default: '',
      },
      'user-uuid': {
        type: String,
        default: '',
      },
      'work-hours-per-day': {
        type: Number,
        default: 8,
      },
    },
    data() {
      return {
        dates: [],
        name: 'dayoff_dates',
        isLoading: false,
        fullPage: false,
        addDaysOpen: false,
        addDaysStartDate: format(new Date(), 'yyyy-MM-dd'),
        addDaysEndDate: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        addDayoffType: 1,
      };
    },
    mounted() {
      this.loadDefaultValue();
    },
    updated() {
    },
    methods: {
      loadDefaultValue: function () {
        if (this.defaultValue.length > 0) {
          this.defaultValue.forEach((item) => {
            this.dates.push(item);
          });
        } else {
          this.addRow();
        }
      },
      deleteRow: function (rowId) {
        this.dates.splice(rowId, 1);

        if (this.dates.length === 0) {
          this.loadDefaultValue();
        }
      },
      addRow: function () {
        if (this.dates.length > 0 || this.defaultValue.length <= 0) {
          this.isLoading = true;
          let date;

          if (this.dates.length > 0) {
            date = this.dates[this.dates.length - 1].date;
          } else {
            date = window.moment().subtract(1, 'days').format('YYYY-MM-DD');
          }

          Axios.get('/api/user/' + this.userUuid + '/dayoff/next-date-should-work/' + date)
            .then((response) => {
              if (response.data.status === 'found') {
                let row = {
                  date: response.data.data.date,
                  type: 1,
                  duration: 3600 * this.workHoursPerDay,
                }
                this.dates.push(row);
                this.isLoading = false;
              }
              else if (response.data.status === 'never') {
                this.isLoading = false;
                let row = {
                  date: '',
                  type: 1,
                  duration: 3600 * this.workHoursPerDay,
                }
                this.dates.push(row);
              }
            })
          ;
        } else if(this.defaultValue.length > 0) {
            this.loadDefaultValue();
        }
      },
      addDays: async function () {

        const startDate = subDays(new Date(this.addDaysStartDate), 1);
        const endDate = new Date(this.addDaysEndDate);

        let date = startDate;
        do {
            const formatedDate = format(date, 'yyyy-MM-dd');
            const res = await Axios.get('/api/user/' + this.userUuid + '/dayoff/next-date-should-work/' + formatedDate);
            date = addDays(date, 1);

            if (res.data.status === 'found') {
                const data = res.data.data;
                const resDate = data.date;
                const resDateCasted = new Date(resDate);

                if ( resDateCasted >= startDate && resDateCasted <= endDate ) {
                    const existDate = this.dates.find((item) => item.date === resDate);
                    if ( !existDate) {
                        let row = {
                            date: resDate,
                            type: this.addDayoffType,
                            duration: 3600 * this.workHoursPerDay,
                        }
                        this.dates.push(row);
                    }
                    else {
                        existDate.type = this.addDayoffType;
                    }
                }
            }
        } while (date < endDate);

      },
      closeAddDays: function () {
        this.addDaysOpen = false;
        this.addDaysStartDate = format(new Date(), 'yyyy-MM-dd');
        this.addDaysEndDate = format(addDays(new Date(), 1), 'yyyy-MM-dd');
      },
      generateName: function (name, pathes) {
        let inputName = this.name;

        pathes.forEach((item) => {
          inputName += '[' + item + ']';
        });

        return inputName;
      },
      updateDuration: function ($event, key) {
        let value = $event.target.value;

        value = Math.min(this.workHoursPerDay, value);
        value = Math.max(0, value);

        this.dates[key].duration = value * 3600;
        this.$forceUpdate();
      }
    },
    watch: {
      value: function (value) {
        if (value.length === 0) {
          this.addRow();
        }
      },
    },
    components: {
      Loading,
    }
  }
</script>
